export default {
  // Page title and description
  appCenterTitle: 'Application Center',
  appCenterDescription: 'Explore rich application ecosystem to boost your productivity',
  searchPlaceholder: 'Search application name or description...',

  // Categories
  categoryAll: 'All',
  categoryAiInnovation: 'AI Innovation',
  categoryAiInnovationDesc: 'AI-driven innovative solutions',
  categoryCustoms: 'Customs Zone',
  categoryCustomsDesc: 'Professional customs business solutions',
  categorySmartLogistics: 'Smart Logistics System',
  categorySmartLogisticsDesc: 'Intelligent and efficient logistics management system',
  categoryBrokerAgent: 'Broker & Agent',
  categoryBrokerAgentDesc: 'Professional brokerage and agency services',
  categoryBookingPortal: 'Booking Portal',
  categoryBookingPortalDesc: 'Efficient and convenient booking service platform',
  categoryToolbox: 'Toolbox',
  categoryToolboxDesc: 'Diverse practical tool collection',

  // Subcategories
  subcategoryUsCanada: 'US-Canada Zone',
  subcategoryEu: 'EU Business',
  subcategoryChina: 'China Business',
  subcategoryOther: 'Other',
  subcategoryPortal: 'Custom Portal',
  subcategoryCollaboration: 'Collaboration Cloud Platform',
  subcategoryUs: 'US Business',
  subcategoryCarrier: 'Carrier',
  subcategoryAgent: 'Agent',
  subcategoryVisualization: 'Visualization',
  subcategoryTools: 'Utility Tools',

  // Application status
  statusNotActivated: 'Not Activated',
  statusPending: 'Pending',
  statusApproved: 'Approved',
  statusRejected: 'Rejected',
  statusDisabled: 'Disabled',

  // Button text
  btnEnterApp: 'Enter App',
  btnApplyAccess: 'Apply Access',
  btnPending: 'Pending',
  btnRejected: 'Rejected',
  btnDisabled: 'Disabled',

  // Modal related
  modalAgreementTitle: 'Apply Access',
  modalAgreementDescription: 'This application requires a signed agreement. Please upload the agreement document with official seal for review and activation.',
  modalRejectionTitle: 'Review Result',
  modalRejectionReasonTitle: 'Rejection Reason',
  modalRejectionDescription: 'Please modify the relevant materials according to the rejection reason and re-upload for re-review.',
  modalUploadAreaTitle: 'Click or drag files to this area to upload',
  modalUploadAreaSubtitle: 'Support PDF, JPG, PNG formats, size not exceeding 10M',
  modalDownloadPrefix: 'If you do not have agreement file, please',
  modalDownloadLink: 'download template',
  modalBtnCancel: 'Cancel',
  modalBtnConfirmUpload: 'Confirm Upload',
  modalBtnReupload: 'Re-upload',
  modalBtnClose: 'Close',
  modalUploadSuccess: 'Upload successful',
  modalReuploadSuccess: 'Re-upload successful, please wait for review',
  modalDownloadTemplateMsg: 'Agreement template downloading...',
  modalSelectFileFirst: 'Please select a file to upload first',

  // Application related messages
  applySuccessMessage: 'Application successful, pending review',
  applyFailedMessage: 'Application failed, please retry',

  // Loading status
  loading: 'Loading...',

  // Error messages
  errorLoadFailed: 'Load failed',
  errorActionFailed: 'Action failed',
  errorUploadFailed: 'Upload failed',

  // Authorized users modal (CCTOWER-2652)
  authUser: 'Auth Users',
  authUserTitle: 'Authorized Users',
  authCurrentApp: 'Current App',
  authAddPlaceholder: 'Enter employee username/name/email/phone, click the search icon to look up or add directly',
  authAddBtn: 'Add',
  authListTitle: 'Authorized Users ({count} / max {max})',
  authListEmpty: 'No authorized users',
  authRoleAdmin: 'Admin',
  authRoleMember: 'Member',
  authRemove: 'Remove',
  authLoadFailed: 'Failed to load authorized users',
  authKeywordEmpty: 'Please enter employee username/name/email/phone',
  authDuplicate: 'This user is already in the authorized list',
  authLimitReached: 'Authorization limit reached ({limit})',
  authUserNotFound: 'No matching tenant user found, please enter the full username/name/email/phone',
  authAddFailed: 'Failed to add, please retry',
  authSearchFailed: 'Failed to search employees, please retry',
  authSearchEmpty: 'No matching employee found',
  authAddSuccess: 'Added successfully',
  authRemoveSuccess: 'Removed successfully',
  authRemoveFailed: 'Failed to remove, please retry',
  authRemoveConfirmTitle: 'Remove Authorized User',
  authRemoveConfirmContent: 'Remove "{name}" from this app\'s authorized list?'
}
